// Форматирование чисел. Читаемость чисел здесь важнее украшений,
// поэтому всё выравнивается по моноширинной сетке и нигде не появляется
// «1.2k» вместо 1234.

export function num(value: number, digits = 0): string {
  if (!Number.isFinite(value)) return '—';
  return value.toLocaleString('ru-RU', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function signed(value: number, digits = 0): string {
  if (!Number.isFinite(value)) return '—';
  const text = num(Math.abs(value), digits);
  if (value > 0) return '+' + text;
  if (value < 0) return '−' + text;
  return '0';
}

export function percent(share: number, digits = 1): string {
  if (!Number.isFinite(share)) return '—';
  return num(share * 100, digits) + '%';
}

export function seconds(value: number): string {
  if (!Number.isFinite(value)) return '—';
  const total = Math.round(value);
  const minutes = Math.floor(total / 60);
  const rest = total % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
}

export function stamp(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const pad = (v: number) => String(v).padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

/** Русское склонение: 1 прогон, 2 прогона, 5 прогонов. */
export function plural(count: number, one: string, few: string, many: string): string {
  const abs = Math.abs(count) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (last > 1 && last < 5) return few;
  if (last === 1) return one;
  return many;
}

export function runsWord(count: number): string {
  return `${num(count)} ${plural(count, 'прогон', 'прогона', 'прогонов')}`;
}
